"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTAFooter = exports.tryGenerateOneLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_i18n_1 = require("@snapchat/web-i18n");
const link_1 = __importDefault(require("next/link"));
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const media_query_1 = require("../../media-query");
const messageLoader_1 = require("../../i18n/messageLoader");
const CTAFooter_module_css_1 = __importDefault(require("./CTAFooter.module.css"));
const MobileCTAVariants_1 = require("./MobileCTAVariants");
const Footer_1 = require("./Footer");
const oneLinkUrlGenerator_1 = require("./oneLinkUrlGenerator");
function addWebClientIdToUrl(url, webClientId) {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set("web_client_id", webClientId);
    return parsedUrl.toString();
}
/**
 * Generates a one link if possible
 * @param oneLinkParams parameters for the one link
 * @param webClientId web client id
 * @param webPageViewTraceId trace id
 */
function tryGenerateOneLink(oneLinkParams, webClientId, webPageViewTraceId) {
    if (typeof window === "undefined" || !oneLinkParams || !webClientId) {
        return;
    }
    const onelinkGenerator = new oneLinkUrlGenerator_1.OneLinkUrlGenerator({
        oneLinkURL: oneLinkParams.oneLinkBaseUrl,
        // @ts-ignore: allow string value
        pidKeysList: oneLinkParams.pidKeys,
        // @ts-ignore: allow string value
        pidStaticValue: oneLinkParams.pidFallbackValue,
        // @ts-ignore: allow string value
        campaignKeysList: oneLinkParams.campaignKeys,
        // @ts-ignore: allow string value
        campaignStaticValue: oneLinkParams.campaignFallbackValue,
        gclIdParam: oneLinkParams.googleClickIdParam,
    });
    onelinkGenerator.setCustomParameter("af_dp", "af_dp", 
    // @ts-ignore: allow string value
    encodeURIComponent(addWebClientIdToUrl(oneLinkParams.deepLinkUrl, webClientId)));
    onelinkGenerator.setCustomParameter("af_ios_url", "af_ios_url", 
    // @ts-ignore: allow string value
    encodeURIComponent(oneLinkParams.iosAppStoreUrl));
    onelinkGenerator.setCustomParameter("af_web_dp", "af_web_dp", 
    // @ts-ignore: allow string value
    encodeURIComponent(oneLinkParams.desktopPageUrl));
    if (webPageViewTraceId) {
        onelinkGenerator.setCustomParameter("trace_id", "trace_id", 
        // @ts-ignore: allow string value
        webPageViewTraceId);
    }
    return onelinkGenerator.generateUrl() || undefined;
}
exports.tryGenerateOneLink = tryGenerateOneLink;
// TODO: using this footer creates a warning about using matching divs, due to using the MediaQueries; we need to debug and fix
/**
 * A footer with a "Open your Snapchat" CTA on desktop, "Open in Snapchat" on mobile
 */
function CTAFooter(props) {
    const { locale, openInSnapchatLink, localeChange, useFixedDesktopFooter, oneLinkParams, webClientId, webPageViewTraceId, pageType, } = props;
    const [messages, setMessages] = (0, react_1.useState)({});
    const [isMounted, setMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setMounted(true);
        void (0, messageLoader_1.loadMessages)(locale).then((messages) => {
            setMessages(messages);
        });
    }, [locale]);
    const ctaUrl = tryGenerateOneLink(oneLinkParams, webClientId, webPageViewTraceId) || openInSnapchatLink;
    const isDesktop = (0, media_query_1.useDesktopMediaQuery)();
    const handleOnClick = (0, react_1.useCallback)(() => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.OpenWebChatCta,
            actionSource: web_blizzard_reporting_1.WebActionSource.TryNowLink,
            webClientId: webClientId ?? "",
        });
    }, [pageType, webClientId]);
    if (!isMounted) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: isDesktop ? ((0, jsx_runtime_1.jsx)(Footer_1.Footer, { locale: locale, openInSnapChatLink: ctaUrl, localeChange: localeChange, useFixedDesktopFooter: useFixedDesktopFooter, pageType: pageType, children: (0, jsx_runtime_1.jsx)("div", { className: CTAFooter_module_css_1.default.desktopButtonWrapper, children: (0, jsx_runtime_1.jsx)(link_1.default, { href: "https://web.snapchat.com/?ref=web_try_now_footer_cta", passHref: true, children: (0, jsx_runtime_1.jsxs)("a", { className: CTAFooter_module_css_1.default.desktopCtaLink, target: "_blank", rel: "noopener", onClick: handleOnClick, children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "yBHoQu", description: "Button text to redirect users to web page where they can input a phone number to send a text link to download Snapchat", defaultMessage: "Try now!" }), (0, jsx_runtime_1.jsx)(web_core_ui_1.DesktopIcon, { size: "MEDIUM" })] }) }) }) })) : ((0, jsx_runtime_1.jsx)(NewMobileCTA, { variant: props.mobileVariant, ctaProps: props })) }));
}
exports.CTAFooter = CTAFooter;
function NewMobileCTA({ variant = MobileCTAVariants_1.MobileCTAVariants.BLACK_AND_YELLOW_DEFAULT, ctaProps, }) {
    const link = tryGenerateOneLink(ctaProps.oneLinkParams, ctaProps.webClientId, ctaProps.webPageViewTraceId);
    const mobileCtaProps = {
        downloadLink: ctaProps.downloadUrl,
        link,
        openInSnapchatLink: ctaProps.openInSnapchatLink,
        onClick: () => {
            const actionUrl = link || ctaProps.openInSnapchatLink;
            if (actionUrl) {
                const actionProps = {
                    pageType: ctaProps.pageType,
                    actionName: web_blizzard_reporting_1.WebActionName.OpenInSnapchatCta,
                    deepLinkUrl: actionUrl,
                    actionSource: web_blizzard_reporting_1.WebActionSource.CTAFooter,
                    webClientId: ctaProps.webClientId ?? "",
                };
                void (0, web_blizzard_reporting_1.reportWebAction)(actionProps);
            }
        },
    };
    const { Component: MobileCTAVariant, replaceFooter } = 
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    MobileCTAVariants_1.MobileCTAVariantsComponentsMap[variant] ||
        MobileCTAVariants_1.MobileCTAVariantsComponentsMap[MobileCTAVariants_1.MobileCTAVariants.BLACK_AND_YELLOW_DEFAULT];
    const ctaUrl = tryGenerateOneLink(ctaProps.oneLinkParams, ctaProps.webClientId, ctaProps.webPageViewTraceId) ||
        ctaProps.openInSnapchatLink;
    return replaceFooter ? ((0, jsx_runtime_1.jsx)("div", { className: CTAFooter_module_css_1.default.mobileCustomFooterWrapper, children: (0, jsx_runtime_1.jsx)(MobileCTAVariant, { ...mobileCtaProps }) })) : ((0, jsx_runtime_1.jsx)(Footer_1.Footer, { locale: ctaProps.locale, openInSnapChatLink: ctaUrl, localeChange: ctaProps.localeChange, useFixedDesktopFooter: ctaProps.useFixedDesktopFooter, pageType: ctaProps.pageType, children: (0, jsx_runtime_1.jsx)(MobileCTAVariant, { ...mobileCtaProps }) }));
}
//# sourceMappingURL=CTAFooter.js.map